import React, {useEffect, useState} from 'react';

import { getContactApproved } from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";

import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownContactApproved = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getContactApproved(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })

    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownContactApproved;

DropdownContactApproved.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownContactApproved.propTypes = {
    onChange: PropTypes.func.isRequired
};